define('services/namedLocalLogger',['config'], function (config) {
    'use strict';

    var LocalLogger = function (namespace) {

        var self = this;

        var console = window.console,
            componentName = namespace;
        var loggedNamespaces = config.loggedNamespaces || [];
        var shouldLog = console && (loggedNamespaces.length === 0 || loggedNamespaces.indexOf(namespace) >= 0);
        function prependMessage (args) {
            // Convert arguments to an actual array instead of an argument object
            var argArray = Array.prototype.slice.apply(args);
            var newArgs = ['[Component: ' + componentName + ']'].concat(argArray);
            return newArgs;
        }

        self.error = function () {
            if (shouldLog) {
                var args = prependMessage(arguments);
                console.error.apply(console, args);
            }
        };

        self.warn = function () {
            if (shouldLog) {
                var args = prependMessage(arguments);
                console.warn.apply(console, args);
            }
        };

        self.info = function () {
            if (shouldLog) {
                var args = prependMessage(arguments);
                console.info.apply(console, args);
            }
        };

        self.debug = function () {
            if (shouldLog) {
                var args = prependMessage(arguments);
                console.log.apply(console, args);
            }
        };

        self.trace = function () {
            if (shouldLog) {
                var args = Array.prototype.slice.call(arguments);
                args = ['TRACE: '].concat(args);
                var argsWithComponentName = prependMessage(args);
                console.log.apply(console, argsWithComponentName);
            }
        };

    };

    return LocalLogger;
});

